/**
 * Convert number of bytes to a human readable format
 * @param bytes     Size to convert
 * @param siUnits        If true then use SI units for size (1024 rather than 1000 per unit threshold) 
 * @param fixed     Number of decimal places to fix to
 */
export function humanByteSize(bytes: number, siUnits=false, fixed=1) {
    const threshold = siUnits ? 1000 : 1024;

    if (Math.abs(bytes) < threshold) {
        return bytes + ' B';
    }

    const units = siUnits
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let unitsIndex = -1;
    const rounding = 10**fixed;

    do {
        bytes /= threshold;
        ++unitsIndex;
    } while (Math.round(Math.abs(bytes) * rounding) / rounding >= threshold && unitsIndex < units.length - 1);
    return bytes.toFixed(fixed) + ' ' + units[unitsIndex];
}

/**
 * Convert a UTC date ("2022-02-28T12:08:48.950Z") to something locale specific and readable
 * @param utcDate   The UTC date string
 * @param format    One of "date", "time" or "datetime"
 */
export function humanUTCDate(utcDate: string, format: "date" | "time" | "datetime" = "datetime") {
    const date = new Date(utcDate);

    if (format === "date") {
        return date.toLocaleDateString();
    } else if (format === "time") {
        return date.toLocaleTimeString();
    } else {
        return date.toLocaleString();
    }
}

/**
 * Convert camel case (camelCase) to something more like heading case (Camel Case)
 * @param camelCase The text to convert
 */
export function humanCamelCase(camelCase: string) {
    const spacedCamel = camelCase.replace(/([A-Z])/g, " $1");

    return spacedCamel.charAt(0).toUpperCase() + spacedCamel.slice(1);
}